var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import qs from 'qs';
import AppState from '../AppState';
/**
 * Fetches plan data from the Drupal API based on the provided ID.
 *
 * @param {string} id - The ID of the plan.
 * @param {String|null} planType - The plan type.
 * @returns {Promise} A Promise that resolves to the plan data.
 * @throws {Error} If the request fails or the response is not ok.
 */
const getNodePlanData = (id, planType = null) => __awaiter(void 0, void 0, void 0, function* () {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { settings } = drupalJsObjects;
    const { baseUrl } = settings;
    const planUrl = `${baseUrl}/jsonapi/node/plan`;
    const queryBuild = {
        filter: {
            field_plan_id: {
                value: id,
            },
        },
        fields: {
            'node--plan': 'title,' +
                'field_plan_id,' +
                'field_plan_one_platform_id,' +
                'field_plan_callout_text,' +
                'field_plan_end_date,' +
                'field_plan_monthly_fee,' +
                'field_plan_monthly_fee_discount,' +
                'field_plan_information,' +
                'field_plan_features,' +
                'field_plan_speed_download,' +
                'field_plan_speed_upload,' +
                'field_plan_documents,' +
                'field_plan_min_cost,' +
                'field_plan_callout_text,' +
                'field_plan_terms',
        },
    };
    if (planType !== null) {
        queryBuild.filter['field_plan_type.name'] = {
            value: planType,
        };
    }
    const queryString = qs.stringify(queryBuild, {
        encode: false,
        addQueryPrefix: true
    });
    return fetch(planUrl + queryString)
        .then(response => {
        if (!response.ok) {
            throw new Error('Couldn\'t get plan data.');
        }
        else {
            return response.json();
        }
    })
        .catch(error => console.log(error));
});
export default getNodePlanData;
